import React, { useState, useEffect, useContext, useRef } from "react"
import { message, Table, Flex, Config, Button, Input, Checkbox} from "antd"
import { UserContext, useUser } from "../contexts/UserContext"
import { getAccounts, fetchSingleAccount, editAccount } from "../api/Cards/users"
import "./AccountManagement.css"
import { useTranslation } from "react-i18next"
import AccountEditorModal from "./AccountEditorModal"
import { useNavigate, useParams } from "react-router-dom"
import { useEventNotifications } from '../Notifications/NotificationScript.js'

const EditAccount = () => {

    const { user } = useContext(UserContext)
    const { getToken, isAdmin, getRole } = useUser()
    const [messageApi, contextHolder] = message.useMessage()
    const [userData, setUserData] = useState(null)
    const navigate = useNavigate()
    const { userid } = useParams()
    const { setup } = useEventNotifications()
    //Avoid triggering another render
    const editUserData = useRef({})
    const { t } = useTranslation()

    useEffect(() => {

        async function getUserData() {
            const data = await fetchSingleAccount({ Token: user.token, UserID: userid })

            if (typeof data === "number") {
                console.log("Error: ", data)
                return
            }

            console.log(data)
            editUserData.current = data
            setUserData(data)
        }

        getUserData();
    }, [])

    function saveSettings() {

        async function sendUserData() {
            const data = await editAccount({ Token: user.token, TargetID: userData.UserID, UserData: { UserID: -1, EMail: editUserData.current.EMail, FirstName: editUserData.current.FirstName, LastName: editUserData.current.LastName, Address: editUserData.current.Address, Role: -1, ResellerName: "", Phone: editUserData.current.Phone, bEmailNotify: editUserData.current.bEmailNotify, bPushNotify: editUserData.current.bPushNotify, bNotifyInfo: editUserData.current.bNotifyInfo, bNotifyWarn: editUserData.current.bNotifyWarn, bNotifyErr: editUserData.current.bNotifyErr, bKeepLoggedIn: editUserData.current.bKeepLoggedIn  } })

            navigate(-1)
        }

        if (!editUserData.current.EMail) {
            message.error("Mail addressen får inte vara tom! ")
            console.log(editUserData.current.EMail)
            return;
        }
        
        setup(getToken());

        sendUserData();
    }


    return (
        <>
            <Flex style={{alignItems:"center", justifyContent:"flex-start", flexWrap:"nowrap", flexDirection:"column"}}>
                <h1>{t('page.editaccount.header')}</h1>
                <div style={{ height: "100px" }}></div>
                { //Dumb React things... defaultValue will only be read and inserted into the text field ONCE, even if the state updates. So we prevent rendering until we have the data
                userData != null &&
                    (<><div style={{ marginTop: "20px" }}><p style={{ width: "100px", display: "inline-block" }}>{t('page.editaccount.email')}: </p>      <Input style={{ width: "400px" }} onChange={(e) => editUserData.current.EMail = e.target.value} defaultValue={userData.EMail} ></Input></div>
                        <div style={{ marginTop: "20px" }}><p style={{ width: "100px", display: "inline-block" }}>{t('page.editaccount.fname')}: </p>     <Input style={{ width: "400px" }} onChange={(e) => editUserData.current.FirstName = e.target.value} defaultValue={userData.FirstName}></Input></div>
                        <div style={{ marginTop: "20px" }}><p style={{ width: "100px", display: "inline-block" }}>{t('page.editaccount.lname')}: </p>   <Input style={{ width: "400px" }} onChange={(e) => editUserData.current.LastName = e.target.value} defaultValue={userData.LastName}></Input></div>
                        <div style={{ marginTop: "20px" }}><p style={{ width: "100px", display: "inline-block" }}>{t('page.editaccount.adress')}: </p>     <Input style={{ width: "400px" }} onChange={(e) => editUserData.current.Address = e.target.value} defaultValue={userData.Address}></Input></div>
                        <div style={{ marginTop: "20px" }}><p style={{ width: "100px", display: "inline-block" }}>{t('page.editaccount.phone')}: </p>     <Input style={{ width: "400px" }} onChange={(e) => editUserData.current.Phone = e.target.value} defaultValue={userData.Phone}></Input></div>
                        <div style={{ marginTop: "20px", marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.emailnotify')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bEmailNotify = e.target.checked} defaultChecked={userData.bEmailNotify}></Checkbox></div>
                        <div style={{ marginTop: "20px", marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.pushnotify')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bPushNotify = e.target.checked} defaultChecked={userData.bPushNotify}></Checkbox></div>
                        <div style={{ marginTop: "20px", marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.remain')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bKeepLoggedIn = e.target.checked} defaultChecked={userData.bKeepLoggedIn}></Checkbox></div>

                        <div style={{ marginTop: "20px", marginLeft: "-310px" }}><p style={{ width: "200px", display: "inline-block", fontStyle: "bold", fontSize: "24px" }}>{t('page.editaccount.notifytypes')}:</p></div>
                        <div style={{ marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.info')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bNotifyInfo = e.target.checked} defaultChecked={userData.bNotifyInfo}></Checkbox></div>
                        <div style={{ marginTop: "20px", marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.warn')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bNotifyWarn = e.target.checked} defaultChecked={userData.bNotifyWarn}></Checkbox></div>
                        <div style={{ marginTop: "20px", marginLeft: "100px" }}><p style={{ width: "200px", display: "inline-block" }}>{t('page.editaccount.err')}:</p>     <Checkbox style={{ width: "400px" }} onChange={(e) => editUserData.current.bNotifyErr = e.target.checked} defaultChecked={userData.bNotifyErr}></Checkbox></div>

                        <Button style={{ marginTop: "40px", width: "500px" }} type="primary" onClick={saveSettings}>{t('page.editaccount.save')}</Button></>)
                }
                {contextHolder}
                <div style={{ marginTop: "60px" }}></div>
            </Flex>
        </>
    )
}

export default EditAccount;